/** Keep the transcript reservation fixed while the Composer changes height. */
export function pinRestingComposerOverlay(element: HTMLElement, isResting: boolean): () => void {
  const overlay = element.closest<HTMLElement>('[data-chat-composer-overlay="true"]');
  if (!overlay) return () => {};
  const child = overlay.firstElementChild as HTMLElement | null;
  const previous = {
    height: overlay.style.height,
    display: overlay.style.display,
    flexDirection: overlay.style.flexDirection,
    justifyContent: overlay.style.justifyContent,
    childFlexShrink: child?.style.flexShrink ?? "",
  };
  overlay.style.height = `${overlay.getBoundingClientRect().height}px`;
  overlay.style.display = "flex";
  overlay.style.flexDirection = "column";
  overlay.style.justifyContent = "flex-end";
  if (child) child.style.flexShrink = "0";
  const footer = element.querySelector<HTMLElement>('[data-chat-composer-footer="true"]');
  const previousFooterStyle = footer?.getAttribute("style") ?? null;
  const previousPosition = element.style.position;
  if (footer) {
    element.style.position = "relative";
    Object.assign(footer.style, {
      position: "absolute",
      bottom: "0",
      right: "0",
      left: isResting ? "auto" : "0",
      height: "48px",
    });
  }
  return () => {
    element.style.position = previousPosition;
    if (footer) {
      if (previousFooterStyle === null) footer.removeAttribute("style");
      else footer.setAttribute("style", previousFooterStyle);
    }
    overlay.style.height = previous.height;
    overlay.style.display = previous.display;
    overlay.style.flexDirection = previous.flexDirection;
    overlay.style.justifyContent = previous.justifyContent;
    if (child) child.style.flexShrink = previous.childFlexShrink;
  };
}
